import {
  TEMPLATE_TABS,
  TemplateTabEnum,
  getTemplateTabIndex
} from './templateTabs';

type Props = {
  activeTab: TemplateTabEnum;
  onChange: (tab: TemplateTabEnum) => void;
};

const backButtonClassName =
  'inline-flex max-w-full items-center justify-center rounded border border-grey-300 bg-white px-4 py-2.5 text-sm font-medium text-grey-900 hover:bg-grey-50';

const nextButtonClassName =
  'inline-flex max-w-full items-center justify-center rounded bg-secondary px-4 py-2.5 text-sm font-semibold text-white hover:bg-secondary-dark';

const TemplateTabNav = ({ activeTab, onChange }: Props) => {
  const activeIndex = getTemplateTabIndex(activeTab);
  const previousTab =
    activeIndex > 0 ? TEMPLATE_TABS[activeIndex - 1] : undefined;
  const nextTab =
    activeIndex >= 0 && activeIndex < TEMPLATE_TABS.length - 1
      ? TEMPLATE_TABS[activeIndex + 1]
      : undefined;

  return (
    <div className="mt-8 flex flex-wrap items-center justify-between gap-3">
      {previousTab ? (
        <button
          type="button"
          className={backButtonClassName}
          onClick={() => onChange(previousTab.value)}>
          &larr; {previousTab.label}
        </button>
      ) : (
        <span />
      )}
      {nextTab ? (
        <button
          type="button"
          className={nextButtonClassName}
          onClick={() => onChange(nextTab.value)}>
          {nextTab.label} &rarr;
        </button>
      ) : (
        <span />
      )}
    </div>
  );
};

export default TemplateTabNav;
